import { indexBy } from 'ramda'

export const useChargingFeeDayTypeEnum = () => {
  const data = [
    {
      id: 1,
      label: '每日',
    },
    {
      id: 2,
      label: '平日',
    },
    {
      id: 3,
      label: '假日(不含例假日)',
    },
    {
      id: 4,
      label: '假日(含例假日)',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
  }
}

export const ChargingTypeEnum = {
  SUPER_FAST: 0,
  FAST: 1,
  SLOW: 2,
}

export const useChargingFeeDiscountTargetEnum = () => {
  const data = [
    {
      id: 0,
      label: '全部',
    },
    {
      id: 1,
      label: '三證',
    },
    {
      id: 2,
      label: '黃卡',
    },
    {
      id: 3,
      label: '殘障車牌',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
  }
}

export const useChargingFeeStatusEnum = () => {
  const statusEnum = {
    PENDING: 0,
    PROCESSING: 1,
    FINISHED: 2,
  }

  const data = [
    {
      id: 0,
      label: '尚未開始',
    },
    {
      id: 1,
      label: '進行中',
    },
    {
      id: 2,
      label: '已結束',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useChargingFeeDiscountTypeEnum = () => {
  const discountTypeEnum = {
    NORMAL: 0,
    PERIOD: 1,
  }
  const data = [
    {
      id: 0,
      label: '常態優惠',
    },
    {
      id: 1,
      label: '期間優惠',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    discountTypeEnum,
    data,
    byId,
  }
}

export const ChargingFeePeakTypeEnum = {
  // 0:無區分尖離峰時段, 1:尖峰時段, 2:離峰時段
  /**
   * 無區分尖離峰時段
   */
  NO_DISTINCTION: 0,
  /**
   * 尖峰時段
   */
  PEAK: 1,
  /**
   * 離峰時段
   */
  OFF_PEAK: 2,
}

export const useChargingFeePeakTypeEnumText = () => {
  const toText = (type: number) => {
    switch (type) {
      case ChargingFeePeakTypeEnum.NO_DISTINCTION:
        return '無區分尖離峰時段'
      case ChargingFeePeakTypeEnum.PEAK:
        return '尖峰時段'
      case ChargingFeePeakTypeEnum.OFF_PEAK:
        return '離峰時段'
      default:
        return '--'
    }
  }

  return {
    ChargingFeePeakTypeEnum,
    toText,
  }
}
